import React from 'react';
import Section from '../Section/Section';
import { experience } from '../../data/portfolioData';
import './Experience.css';

export const Experience = () => (
  <Section id="experience" path="experience/" title="Experience">
    <ol className="timeline">
      {experience.map((job, i) => (
        <li className="tl-item" key={job.id} id={`experience-${job.slug}`}>
          <span className={i === 0 ? 'tl-node is-current' : 'tl-node'} aria-hidden="true" />
          <p className="tl-when">
            {job.duration}
            <span className="tl-where">{job.location}</span>
          </p>
          <h3 className="tl-role">
            {job.role}
            <span className="tl-company">{job.company}</span>
          </h3>
          <ul className="tags">
            {job.stack.map((tech) => (
              <li key={tech}>{tech}</li>
            ))}
          </ul>
          <ul className="marks">
            {job.description.map((line, k) => (
              <li key={k}>{line}</li>
            ))}
          </ul>
        </li>
      ))}
    </ol>
  </Section>
);

export default Experience;
